module.exports = __webpack_public_path__ + "e72718f4fcc37364817521bb11b096fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/purple-hot-air-balloon.png
// module id = 2858
// module chunks = 0